/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { LeadStatus } from './LeadStatus';
import {
    LeadStatusFromJSON,
    LeadStatusFromJSONTyped,
    LeadStatusToJSON,
} from './LeadStatus';

/**
 * 
 * @export
 * @interface FindAllLeadStatuses200Response
 */
export interface FindAllLeadStatuses200Response {
    /**
     * 
     * @type {Array<LeadStatus>}
     * @memberof FindAllLeadStatuses200Response
     */
    data?: Array<LeadStatus>;
}

/**
 * Check if a given object implements the FindAllLeadStatuses200Response interface.
 */
export function instanceOfFindAllLeadStatuses200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindAllLeadStatuses200ResponseFromJSON(json: any): FindAllLeadStatuses200Response {
    return FindAllLeadStatuses200ResponseFromJSONTyped(json, false);
}

export function FindAllLeadStatuses200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllLeadStatuses200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(LeadStatusFromJSON)),
    };
}

export function FindAllLeadStatuses200ResponseToJSON(value?: FindAllLeadStatuses200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(LeadStatusToJSON)),
    };
}

